<template>
  <div class="memeber-wrapper">
    <div
      style="
        font-size: 22px;
        text-align: center;
        font-weight: bold;
        padding: 20px 0;
      "
    >
      {{ userName }}
    </div>
    <div class="menu-wrapper">
      <div class="round header"></div>
      <div style="margin-left: 20px; font-size: 16px; color: #5c94be">
        联盟商家:{{ sn }}
      </div>
      <!--会员中心左侧列表-->
      <div class="inner_wrapper">
        <div class="menu-part manage">
          <ul>
            <li
              :class="active == 1 ? 'active' : ''"
              style="cursor: pointer"
              @click="gotoPage(1)"
            >
              我的资料
            </li>
            <li
              :class="active == 2 ? 'active' : ''"
              style="cursor: pointer"
              @click="gotoPage(2)"
            >
              补充我的资料
            </li>
            <li
              :class="active == 3 ? 'active' : ''"
              style="cursor: pointer"
              @click="gotoPage(3)"
            >
              商品图管理
            </li>
            <li style="cursor: pointer">
              <router-link
                :to="{
                  path: '/leagueAgreement',
                }"
                target="_blank"
              >
                开心云商规则
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="round bottom"></div>
    </div>
    <!--会员中心首页右侧-->
    <div class="content_wrapper">
      <div class="content-box header"></div>
      <router-view></router-view>
      <div class="content-box bottom"></div>
    </div>
    <!--会员中心首页右侧结束-->
  </div>
</template>
<style lang="less">
@import "../../assets/css/user.less";
</style>
<script>
import { isApplyLeague } from "api/user";
export default {
  data() {
    return {
      sn: "",
      applyStatus: "",
      active: 1,
    };
  },
  mounted() {},
  created() {
    this.userName = localStorage.getItem("name");
    this.isApplyLeague();
    if (this.$route.query.page == "businessLeague") {
      this.active = 1;
    } else if (this.$route.query.page == "editLeague") {
      this.active = 2;
    } else {
      this.active = 3;
    }
  },
  methods: {
    //查询是否申请过联盟商家
    isApplyLeague() {
      isApplyLeague({}).then((res) => {
        if (res.data) {
          if (res.resCode == 1) {
            this.applyStatus = res.data.status;
            this.sn = res.data.sn;
          }
        }
      });
    },
    gotoPage(type) {
      this.active = type;
      if (type == 1) {
        this.$router.push({
          path: "/myData/businessLeague",
          query: { status: this.$route.query.status, page: "businessLeague" },
        });
      } else if (type == 2) {
        this.$router.push({
          path: "/myData/editLeague",
          query: { status: this.$route.query.status, page: "editLeague" },
        });
      } else {
        this.$router.push({
          path: "/myData/shopImg",
          query: { status: this.$route.query.status, page: "shopImg" },
        });
      }
    },
  },
};
</script>

<style scoped>
.active {
  background: #e8f1f8;
  color: orange;
}
</style>



// WEBPACK FOOTER //
// index.vue?45f375ea